// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3FEmg","footer":"ReportModalFilter_footer__ez9wZ"};